import React from 'react'
import { MyUserGroup } from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import { UserInfo } from '@Entities/user/user'

interface EditActionsGroupRowProps {
    myUserGroup: MyUserGroup
    rightsholderUser: UserInfo
}

const EditActionsGroupRow = (props: EditActionsGroupRowProps) => {
    const { myUserGroup, rightsholderUser } = props

    return (
        <p>
            <span>{myUserGroup.checked ? 'Add' : 'Removing'}&nbsp;</span>
            <strong title={rightsholderUser.firstName + ' ' + rightsholderUser.lastName}>
                {rightsholderUser.firstName} {rightsholderUser.lastName}
            </strong>
            <span>&nbsp;{myUserGroup.checked ? 'to' : 'from'}&nbsp;</span>
            <strong>{myUserGroup.name}</strong>
        </p>
    )
}

export default EditActionsGroupRow
